<template>
    <div :class="colGrid">
        <DataTable 
            :value="dados ? dados : []" 
            class="p-datatable-responsive-demo table-seplag" 
            :dataKey="chave ? chave : ''" 
            selectionMode="single"
            :paginator="paginacao"           
            paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
            :rowsPerPageOptions="[10,20,50]"
            currentPageReportTemplate="{first} de {last} - {totalRecords} registros"
            :rows="linhas ? linhas : 10" 
            :filters="filtros" 
            :resizableColumns="false" 
            :scrollable="false" 
            @page="paginacaoEvent($event)"  
            :totalRecords="totalRegistro" 
            :lazy="true" 
            :loading="loading"
            :key="totalRegistro"
            :first="firstRecordIndex"
        >
            <template #header v-if="hasExibirCabecalho">
                <div class="table-header p-grid p-fluid p-justify-between p-align-center">
                    <div class="p-col-12 p-md-8 ">
                        <div style="display:flex; flex-direction:row; justify-content: flex-start">
                            <div style="margin:5px">
                                <Button label="Adicionar" icon="pi pi-plus" class="p-button-raised" @click="onAdicionarDado" v-if="onAdicionarDado" />
                            </div> 

                            <slot name="buttonsHeader"></slot>

                        </div>
                    </div>
                    <div class="p-col-12 p-md-4 table-search" v-if="onSearch">
                        <div class="p-grid p-fluid p-align-center">
                            <div class="p-col">
                                <InputText 
                                    v-model="filtro" 
                                    :placeholder="placeholderSearch" 
                                    size="50" 
                                    @keyup.enter="onSearch(filtro)"
                                />
                            </div>
                            <i class="pi pi-search " @click="onSearch(filtro)" style="cursor: pointer;"></i>
                        </div>    
                    </div>
                </div>
            </template>
            
            <Column 
                v-for="campo in camposTabela.filter(elemento => { return !elemento.ocultar })" 
                :key="campo.nome" 
                :headerStyle="larguraColuna(campo.tamanho)"
                :field="campo.nome" 
                :header="campo.titulo" 
                :bodyStyle="alinhaColuna(campo.alinhamento)" 
            >
                <template #body="slotProps" >
                    <span class="p-column-title">{{campo.titulo}}:</span>                        
                    {{ colunaTabela(slotProps.data, campo) }}
                </template>
            </Column>

            <slot></slot>

            <Column headerStyle="width: 8em" bodyStyle="text-align: center" 
                header="Ação" v-if="hasEventoAcao">

                <template #body="slotProps">                        
                    <Button 
                        type="button" 
                        icon="pi pi-pencil" 
                        @click="onEditarDado(slotProps.data)" 
                        v-if="onEditarDado"
                        class="p-button-success" 
                        :style="onExcluirDado ? 'margin-right: .5em' : ''"
                    />

                    <Button 
                        type="button" 
                        icon="pi pi-trash" 
                        @click="exibirTelaConfirmacao(slotProps.data)" 
                        v-if="onExcluirDado"
                        class="p-button-danger"
                    />

                    <slot name="acoes"></slot>
                </template>
            </Column>

            <template #empty>
                <div style="text-align:center;margin: 1rem;">
                    <span style="font-family: sans-serif;font-size:1.2rem;font-weight: 500">
                        Nenhum registro encontrado
                    </span>
                </div>
            </template>
        </DataTable>

        <confirmacao 
            tituloTela="Confirmação" 
            v-model="exibirConfirmacao" 
            :onConfirmar="confirmarApagar" 
            textoConfirmcao="Deseja realmente remover o registro selecionado?"
            tamanhoTela=""
            labelConfirmar="Sim"
            labelCancelar="Não"
        /> 

    </div>
</template>

<script>
import classeCss from '../common/grid'
import Confirmacao from './Confirmcao.vue'
import moment from 'moment'
import { baseApiUrl } from '@/config/global'
// import { number } from 'yargs'

export default {
    name: 'TableSeplag',
    components: { Confirmacao },
    props: {
        tituloTabela: {
            // Especifica o titulo a ser exibido no cabeçalho da tabela
            type: String
        },        
        cols: {
            // Numero de colunas do grid css
            type: String
        },
        paginacao: {
            // Informa se a grid trabalha com a paginação
            type: Boolean,
            default: true       
        },
        hasExibirCabecalho: {
            // Informa se deve exibir o cabeçcalho
            type: Boolean,
            default: true
        },
        linhas: {
            // Número de linhas quando a grid é paginada
            type: Number
        },  
        urlPaginacao:{
            type: String
        },      
        queryPagina: {
          // Numero da pagina atual
          type: String,
          default : '?size=10&page=0'
        },
        totalRegistro: {
          // Total de registros do resultado
          type: Number,
          default: null
        },
        dados: {
            // A coleção de dados que será renderizada na tabela
            type: Array,
            required: true
        },
        campos: {
            // Lista de campos que será utilizada para formatar a grid
            type: Array
        },
        chave: {
            // Nome do campo chave utilizado como chave dos dados
            type: String
        },
        onAdicionarDado: {
            // Evento disparado na adição do registro
            type: Function
        },
        onEditarDado: {
            // Evento disparado na edição do registro
            type: Function
        },
        onExcluirDado: {
            // Evento disparado na exclusão do registro
            type: Function
        },
        onCarregarDados: {
          // Evento disparado para carregar dados
          type: Function
        },
        placeholderSearch:{
            type:String,
            default:"Digite sua pesquisa"
        },
        onSearch:{
            type: Function
        },
        onSearchPaginacao:{
            type: Function,
            default: null
        },
        firstRecordIndex:{
            type: Number,
            default: 0
        }


    },
    computed: {
        colGrid() {
            return classeCss(this.cols ? this.cols : '12')
        },
        camposTabela() {
            return this.campos ? this.campos : []
        },
        hasEventoAcao(){
            return this.onEditarDado || this.onExcluirDado
        }
    },
    data() {
        return {
            filtro:'',
            filtros: {},
            exibirConfirmacao: false,
            registro: {},
            loading: false
        }
    },
    methods: {
        
        colunaTabela(objeto, campo) {            
            var dataColuna = ''
            if (campo.nome.indexOf('.') < 0) {                
                if(campo.displayFormat){

                    if(campo.displayFormat =="currency-pt-br"){
                        
                        const currencyBRL = (value) => {
                        const formattedValue = value.toLocaleString(
                                'pt-BR', 
                                { style: 'currency', currency: 'BRL' }
                            );

                            return formattedValue;
                        };
                        return currencyBRL(objeto[campo.nome])
                    }
                    else{
                        dataColuna = moment(objeto[campo.nome]).format(campo.displayFormat)
                        return dataColuna
                    }
                }                
                return  objeto[campo.nome]
            }            
            else {
                
                var arryCampos = campo.nome.split('.')
                let colunasArray = objeto
                for(let i=0;i<arryCampos.length;i++){
                    if(colunasArray[arryCampos[i]]){
                        colunasArray = colunasArray[arryCampos[i]]
                    }else{
                        break
                    }
                }
                
                if(campo.displayFormat){
                    if(moment(colunasArray).isValid()){
                        dataColuna = moment(colunasArray).format(campo.displayFormat)
                        return dataColuna
                    }
                }                
                return colunasArray? typeof colunasArray != 'object'? colunasArray : 'Não Informado'  : ''
                // return objeto[arryCampos[0]][arryCampos[1]][arryCampos[2]] ? objeto[arryCampos[0]][arryCampos[1]][arryCampos[2]] : objeto[arryCampos[0]][arryCampos[1]]
            }
        },
        larguraColuna(tamanho) {
            
            // Retorna a columa da grid especificada dinamicamente
            if(tamanho && tamanho.indexOf('.')< 0){
                return tamanho ? `width: ${tamanho}px;` : '';
            }else if (tamanho){
                let css = tamanho.split('.')
                return tamanho ? `width: ${css[0]}${css[1]};` : '';
            }else{
                return ''
            }
        },
        alinhaColuna(alinhamento) {
            // Os tipos de valores para a propriedade alinhamento são: left, center, right
            if(alinhamento){
                return 'text-align: ' + alinhamento
            }
            else {
                return ''
            }
        },
        exibirTelaConfirmacao(dado){
            // Recebe o registro a ser removido
            this.registro = dado
            // Exibie a tela
            this.exibirConfirmacao = true
        },
        confirmarApagar(){
            // Dispara o evento
            this.onExcluirDado(this.registro)
        },
        async paginacaoEvent(event){
            if (this.onSearchPaginacao && this.filtro) {
              //this.onSearchPaginacao(this.loading,event.originalEvent.rows,event.originalEvent.page,this.filtro)
              this.onSearchPaginacao(this.loading,event.originalEvent.page,this.filtro)
                this.filtro = null
                
            }else{
                if(this.onSearchPaginacao){
                    this.onSearchPaginacao(event.originalEvent.rows,event.originalEvent.page)
                    
                }else{
                    this.loading = true
                    let res = await this.$http.get(`${baseApiUrl}/${this.urlPaginacao}?size=${event.originalEvent.rows}&page=${event.originalEvent.page}`)
                    if(res.status == 200){
                        this.$emit('update:dados', res.data.content)
                        this.$emit('update:totalRegistro', res.data.totalElements)
                        this.filtro = null
                    }
                    this.loading = false
                }
            }
        },
        
    }
}
</script>

<style lang="scss" scoped>
    .p-datatable-responsive-demo .p-datatable-tbody > tr > td .p-column-title {
        display: none;
    }

    .cabecalho-buttons {
        display: flex;
    }

    @media screen and (max-width: 40em) {
        /deep/ .p-datatable {
            &.p-datatable-responsive-demo {
                .p-datatable-thead > tr > th,
                .p-datatable-tfoot > tr > td {
                    display: none !important;
                }
                .p-datatable-row{
                    display: flex;
                    flex-direction: column;
                }

                .p-datatable-tbody > tr > td {
                    text-align: left;
                    display: block;
                    width: 100%;
                    float: left;
                    clear: left;
                    border: 0 none;

                    .p-column-title {
                        padding: .4rem;
                        min-width: 30%;
                        display: inline-block;
                        margin: -.4em 1em -.4em -.4rem;
                        font-weight: bold;
                    }

                    &:last-child {
                        border-bottom: 1px solid var(--surface-d);
                        text-align: center !important;
                        display: flex !important;

                        & button{
                            width: 100%;
                        }
                    }
                }
            }
        }
    }


    .table-header.p-grid {
        margin-top: 0;
        padding: 0 10px 0 10px;
    }

    .table-search, .table-search .p-grid {
        padding: 0 5px 0 5px;
        margin-top: 0;
    }

</style>